import { render, staticRenderFns } from "./OrderOrders.vue?vue&type=template&id=1e2f43a6&"
import script from "./OrderOrders.vue?vue&type=script&lang=js&"
export * from "./OrderOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports